import { Outlet } from "react-router-dom";
import { useState } from "react";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { SessionExpiryBanner } from "@shared/ui/SessionExpiryBanner";

export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div id="appLayout">
      <div
        id="sidebarOverlay"
        className={sidebarOpen ? "open" : ""}
        onClick={() => setSidebarOpen(false)}
      />
      <Sidebar open={sidebarOpen} onNavigate={() => setSidebarOpen(false)} />
      <Topbar onToggleSidebar={() => setSidebarOpen((o) => !o)} />
      <main id="mainContent">
        <SessionExpiryBanner />
        <Outlet />
      </main>
    </div>
  );
}
